import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base';

@Injectable()
export class RecordService extends ApiService {
  searchHistoryPurchase(request: any): Observable<any> {
    return this.post('/backoffice/api/orders', request);;
  }

  detailPurchase(param: any): Observable<any> {
    return this.get(`/backoffice/api/orders/customer/${param.customerId}/search/${param.searchId}/detail`);
  }

  approvePurchase(param: any): Observable<any> {
    return this.patch(`/backoffice/api/orders/customer/${param.customerId}/search/${param.searchId}/approve`);
  }

  downloadPurchase(param: any): Observable<any> {
    return this.getFile(`/backoffice/api/orders/customer/${param.customerId}/search/${param.searchId}/support-file`);
  }
}
